import { useCallback, useEffect, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { NetInfoStateType, useNetInfo } from '@react-native-community/netinfo';

import {
    setConnectionIsCorrect,
    setShowConnectionIndicator,
} from 'store/connection/actions';
import {
    selectShowConnectionIndicator,
    selectWarnOnMobileData,
} from 'store/connection/selectors';
import { selectConnectionType } from 'store/user/selectors';

const useConnectionIndicator = () => {
    const { type } = useNetInfo();
    const selectedConnectionType = useSelector(selectConnectionType);
    const dispatch = useDispatch();
    const prevConnectionTypeRef = useRef<NetInfoStateType | null>(null);
    const showConnectionDialog = useSelector(selectShowConnectionIndicator);
    const shouldWarnOnMobileData = useSelector(selectWarnOnMobileData);

    const handleShowDialog = useCallback(() => {
        dispatch(setShowConnectionIndicator(true));
    }, []);

    const handleCloseDialog = useCallback(() => {
        dispatch(setShowConnectionIndicator(false));
    }, []);

    useEffect(() => {
        if (prevConnectionTypeRef.current !== type) {
            if (
                type === NetInfoStateType.cellular &&
                selectedConnectionType === NetInfoStateType.wifi
            ) {
                handleShowDialog();
                dispatch(setConnectionIsCorrect(true));
            } else if (
                (type === NetInfoStateType.wifi &&
                    prevConnectionTypeRef.current ===
                        NetInfoStateType.cellular &&
                    selectedConnectionType === NetInfoStateType.wifi) ||
                (type === NetInfoStateType.cellular &&
                    selectedConnectionType === NetInfoStateType.cellular)
            ) {
                handleCloseDialog();
                dispatch(setConnectionIsCorrect(false));
            }
        }

        prevConnectionTypeRef.current = type;
    }, [type, selectedConnectionType, handleShowDialog]);

    return {
        showConnectionDialog,
        handleShowDialog,
        handleCloseDialog,
        selectedConnectionType,
        connectionType: type,
        prevConnectionTypeRef,
        shouldWarnOnMobileData,
    };
};

export default useConnectionIndicator;
